import React, { Component } from "react"
import Footer from "./src/components/footer"
import VideoWrapper from "./src/components/video-wrapper"
import CanvasWrapper from "./src/components/canvas-wrapper"

class Wrapper extends Component {
  render() {
    return (
      <>
        <VideoWrapper />
        {this.props.children}
        <Footer />
        <CanvasWrapper className={`fixed top-0 left-0 z-0 w-screen h-screen`} />
      </>
    )
  }
}

export default Wrapper